import React from "react";
import Layout from "../Layout";
import Cover from "../Reuse/Cover";
import CoverImg from "../Photo/Cover-exp.jpg";
import Nectec from "./Nectec";
import Mfec from "./Mfec";

const Main = () => {
  return (
    <Layout>
      <Cover
        img={CoverImg}
        description1="Experiences"
        description2="better opportunity"
      />
      <Nectec />
      <Mfec />
    </Layout>
  );
};

export default Main;
